import { format } from "date-fns";

export function formatDate(date: Date | string) {
  const dateObject = typeof date === "string" ? new Date(date) : date;

  return format(dateObject, "dd LLL yyyy");
}
